import { dayOf, REVIEW_COPY, sealLine, type PublicReview, type Timezone } from "@fusiqo/vozqi-shared";
import { ReviewStars } from "./review-stars";

/**
 * A WRITTEN REVIEW, READ (spec 2026-10-21 §7-§8): its stars, her words, the
 * seal and the business's reply under it. The document's card, «Perfil
 * público» → «Reseñas» and the public profile draw the same body; in the kit
 * because the profile's light entry (`share/`) reads it too.
 */
export function ReviewBody({
  review,
  businessName,
  timezone,
}: {
  review: Pick<PublicReview, "stars" | "comment" | "seal" | "reply">;
  businessName: string;
  timezone: Timezone;
}) {
  return (
    <div style={{ display: "grid", gap: 8 }}>
      <ReviewStars value={review.stars} />
      {review.comment === "" ? null : <p style={{ margin: 0, whiteSpace: "pre-wrap" }}>{review.comment}</p>}
      <p style={{ margin: 0, color: "var(--ink-soft)", fontSize: 13.5 }}>{sealLine(review.seal)}</p>
      {review.reply === null ? null : (
        <div style={{ borderLeft: "3px solid var(--line)", paddingLeft: 12, display: "grid", gap: 4 }}>
          <p style={{ margin: 0, fontSize: 13, color: "var(--ink-soft)" }}>
            {REVIEW_COPY.replyHeading(businessName, dayOf(review.reply.repliedAt, timezone))}
          </p>
          <p style={{ margin: 0, whiteSpace: "pre-wrap" }}>{review.reply.text}</p>
        </div>
      )}
    </div>
  );
}
